import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center h-[calc(100vh-64px)] text-center px-4">
      <h1 className="absolute bottom-1/4 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mt-6 mb-2">
          页面未找到
        </h2>
        <p className="text-foreground-600 mb-6">您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-flex px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-md font-medium text-sm transition-colors whitespace-nowrap"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}